import * as TemplateTypes from 'types/template.types';
import BaseScene from './base';
import { showBanner, adEvents } from 'util/ad-util';
import { useModule } from 'src/modules/modules';
import { delay } from 'src/util/util';

class Preload extends BaseScene {
    constructor(){
        super({ 
            key: TemplateTypes.Scene.PRELOAD, 
            transition: {
                scene: {
                    enter: {
                        name: 'fade',
                        duration: 500
                    },
                    exit: {
                        name: 'fade',
                        duration: 500
                    }
                },
                menu: {
                    exit: {
                        name: 'fade',
                        duration: 500
                    },
                    enter: {
                        name: 'fade',
                        duration: 500
                    }
                },
            }
        });
    }

    // init() {
    //     showBanner();
    // }

    preload(){
        const { global, audio } = useModule();

        audio.init();

        this.load.on('progress', (value: number) => global.setPreloadProgress(value));
        this.load.on('complete', () => global.setPreloadProgress(100));

        //Audio
        this.load.audio('MUSIC_menu', 'audio/aetherial.mp3');
        this.load.audio('MUSIC_game', 'audio/loose_relaxed.mp3');
        this.load.audio('FX_menu_btn', 'audio/tap_neutral_0.mp3');
        this.load.audio('FX_menu_btn_play', 'audio/tap_neutral_2.mp3');
        this.load.audio('FX_success', 'audio/success_1.mp3');
        this.load.audio('FX_failure', 'audio/failure_deep.mp3');
        this.load.audio('FX_bounce', 'audio/bounce_1.mp3');
        this.load.audio('FX_tap', 'audio/tap_neutral_2.mp3');
        // this.load.audio('FX_fact', 'audio/sleep_1.mp3');
        this.load.audio('FX_ascending_1', 'audio/notes_ascending_0.mp3');
        this.load.audio('FX_ascending_2', 'audio/notes_ascending_1.mp3');
        this.load.audio('FX_ascending_3', 'audio/notes_ascending_2.mp3');
        this.load.audio('FX_ascending_4', 'audio/notes_ascending_3.mp3');
        this.load.audio('FX_ascending_5', 'audio/notes_ascending_4.mp3');
        this.load.audio('FX_ascending_6', 'audio/notes_ascending_5.mp3');
        this.load.audio('FX_ascending_7', 'audio/notes_ascending_6.mp3');
        this.load.audio('FX_ascending_8', 'audio/notes_ascending_7.mp3');

        const resolution = "200x200"; 

        //Images
        this.load.image('FX_bg_event-horizon', 'images/FX_bg_event-horizon.png');
        this.load.image('FX_pointer_wave', 'images/FX_pointer_wave.png');
        this.load.image('FX_pointer_wave_filled', 'images/FX_pointer_wave_filled.png');
        this.load.image('donut', 'images/donut.png');

    }

    async create(){
        super.enter();
        const { global } = useModule();

        if (global.platform !== 'web'){
            if (!global.isFirstRun){
                let bannerSuccess = await showBanner();
                if (bannerSuccess){
                    await delay(1500); //Delay to prevent stuttering on menu as banner ad is shown
                } else {
                    console.warn('Preload: Banner Ad failed to load');
                }
            } else {
                console.log("Banner Ad not shown since this is the first time the app has been run.");
            }
        }

        //await delay(10000); //Uncomment to test preload screen on web

        this.exit('Menu');
    }
}

export default Preload;